import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {NatGetApplicationStatusDetail} from '../repository/NatGetApplicationStatus'
import {StyledTableCaption, TableRowName, TableRowNameTop} from '../../../../styledComponents/adminPage/Table'
import {
    APPLY_CATEGORY,
    APPLY_IRREGULAR_PATTERN,
    HAVE_OR_NOT,
    MESSAGE_TYPE,
    PET_TYPE,
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS,
    ROLE_FOR_ADMINISTRATOR,
} from '../../../../CodeMaster'
import {getApplicant} from '../common/helper/NatApplicationHelper'
import {BackLink, PrintLink} from '../../../../styledComponents/adminPage/Links'
import {Box, Table, TableBody, TableRow} from '@mui/material'
import moment from 'moment'
import {
    ApplyButtonTextWithIcon,
    ApplyReceptionOutlinedButton,
    ApplyRejectionOutlinedButton,
    DelegateApprovalButton,
    SpApplicationDetailInfoContent,
    SpApplicationDetailInfoContentName,
    SpApplicationDetailInfoContentValue,
    SpApplicationInfoArea,
    SpApplicationInfoFooter,
    SpApplyCategory,
    SpApplyStatusCell,
    SpBackLinkArea,
    SpDelegateApprovalButton,
    SpPageFooterArea,
    StyledTableCell,
} from '../common/admin/NatAdminApplicationCommon'
import {
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    RightRowFlexContainer,
} from '../../../../styledComponents/FlexComponents'
import NatAdminApplicationRejectionDialog from '../common/admin/NatAdminApplicationRejectionDialog'
import ReactToPrint from 'react-to-print'
import {Messages} from '../../../../Messages'
import {HeadingAreaMessageParams} from '../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import NatAdminApplicationReceptionDialog from '../common/admin/NatAdminApplicationReceptionDialog'
import {NatApplicationStatusComponent} from '../common/admin/NatApplicationStatusComponent'
import {HKConstants} from '../../../../HKConstants'
import AuthorityChecker from '../../../../components/AuthorityChecker'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import NatAdminApplicationApprovalDelegateDialog from '../common/admin/NatAdminApplicationApprovalDelegateDialog'
import NatAdminApplicationApprovalDirectorDelegateComponent
    from '../common/admin/NatAdminApplicationApprovalDirectorDelegateComponent'
import NatAdminApplicationApprovalDialog from '../common/admin/NatAdminApplicationApprovalDialog'
import {NatPetBreedingApplicationDocument} from '../common/admin/print/NatPetBreedingApplicationDocument'
import {NatPetBreedingDetail} from '../repository/NatGetPetBreeding'
import {getFormattedDate} from './helper/NatPetBreedingApplyHelper'
import {StyledDiv, StyledImg} from '../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {
    NatPutRejectionPetBreedingRequest,
    NatPutRejectionPetBreedingResponse,
} from '../repository/NatPutRejectionPetBreedingRequest'
import {
    NatPutApprovalPetBreedingResponse,
    NatPutApprovalsPetBreedingRequest,
} from '../repository/NatPutApprovalsPetBreedingRequest'
import NatAdminApplicationApprovalPetChairmanDelegateComponent
    from '../common/admin/NatAdminApplicationApprovalPetChairmanDelegateComponent'
import {getRandomKey} from '../../../common/util/Natutil'
import {NatAdminSpApplicationTabComponent} from '../common/admin/NatAdminSpApplicationTabComponent'
import {formatDateTimeWithoutSeconds} from '../../../../formatters/formatDate'
import {Check, Close} from '@mui/icons-material'
import {AppAdminContext} from '../../../../app/AppAdminContext'
import {NatFileRepo} from '../../files/repository/NatFileRepo'
import {PrintContentArea} from '../common/admin/print/NatAdminApplicatioPrintCommonStyle'
import {NatAdminApplicationCommentToAssocDirector} from '../common/admin/NatAdminApplicationCommentToAssocDirector'
import {Location} from 'react-router-dom'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    condominiumCd: string
    applyId: string
    applicationRepo: NatApplicationRepo
    fileRepo: NatFileRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    petBreedingDetail: NatPetBreedingDetail
    applicationStatusDetail: NatGetApplicationStatusDetail
    healthCenterDogLicenseDataUrl: string
    rabiesPreventionInjectionCertificationDataUrl: string
    rejectionComment: string
    receptionComment: string
    approvalComment: string
    isLoadCompleted: boolean
    dialogStatus: Nullable<DialogContentType>
    actingChecked: boolean
    actingPetChecked: boolean
    residentApplyProcess: RESIDENT_APPLY_PROCESS
}

type DialogContentType = 'reception' | 'rejection' | 'delegate' | 'delegateApproval'
    | 'delegateRejection' | 'approval' | 'delegatePetClub' | 'delegateApprovalPetClub' | 'delegateRejectionPetClub'

class NatAdminPetBreedingPage extends Component<Props & AdminPagePropsSet, States> {
    declare context: React.ContextType<typeof AppAdminContext>
    ownUrl: string
    applicationRef: RefObject<HTMLDivElement>
    contractRef: RefObject<HTMLDivElement>
    roleId: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        this.state = {
            petBreedingDetail: {
                applyId: '',
                applyStatus: '',
                condominiumCd: '',
                condominiumName: '',
                ridgeName: '',
                roomNumber: '',
                applicantFamilyName: '',
                applicantFirstName: '',
                applyDate: '',
                petType: '',
                petBreed: '',
                havePetStartMonth: '',
                healthCenterDogLicense: {
                    fileNumber: 0,
                    path: '',
                },
                rabiesPreventionInjectionCertification: {
                    fileNumber: 0,
                    path: '',
                },
                version: 0,
            },
            healthCenterDogLicenseDataUrl: '',
            rabiesPreventionInjectionCertificationDataUrl: '',
            applicationStatusDetail: {
                applyStatusInfo: [],
            },
            rejectionComment: '',
            receptionComment: '',
            approvalComment: '',
            actingChecked: true,
            actingPetChecked: true,
            dialogStatus: null,
            isLoadCompleted: false,
            residentApplyProcess: RESIDENT_APPLY_PROCESS.RECEPTION,
        }

        this.ownUrl = this.props.location.pathname
        this.applicationRef = React.createRef()
        this.contractRef = React.createRef()

        this.handleDialogCancelClick = this.handleDialogCancelClick.bind(this)
        this.handleReceptionClick = this.handleReceptionClick.bind(this)
        this.handleReceptionOkClick = this.handleReceptionOkClick.bind(this)
        this.handleRejectionClick = this.handleRejectionClick.bind(this)
        this.handleRejectionOkClick = this.handleRejectionOkClick.bind(this)
        this.handleApprovalClick = this.handleApprovalClick.bind(this)
        this.handleDelegateApprovalPetClubClick = this.handleDelegateApprovalPetClubClick.bind(this)
        this.handleApprovalOkClick = this.handleApprovalOkClick.bind(this)
        this.handleDelegateClick = this.handleDelegateClick.bind(this)
        this.handleDelegatePetClubClick = this.handleDelegatePetClubClick.bind(this)
        this.handleDelegateApprovalClick = this.handleDelegateApprovalClick.bind(this)
        this.handleDelegateApprovalOkClick = this.handleDelegateApprovalOkClick.bind(this)
        this.handleDelegateApprovalPetClubOkClick = this.handleDelegateApprovalPetClubOkClick.bind(this)
        this.handleDelegateRejectionClick = this.handleDelegateRejectionClick.bind(this)
        this.handleDelegateRejectionPetClubClick = this.handleDelegateRejectionPetClubClick.bind(this)
        this.handleDelegateRejectionOkClick = this.handleDelegateRejectionOkClick.bind(this)
        this.handleDelegateRejectionPetClubOkClick = this.handleDelegateRejectionPetClubOkClick.bind(this)
        this.handleRejectionCommentChange = this.handleRejectionCommentChange.bind(this)
        this.handleReceptionCommentChange = this.handleReceptionCommentChange.bind(this)
        this.handleApprovalCommentChange = this.handleApprovalCommentChange.bind(this)
        this.onChangeActingChecked = this.onChangeActingChecked.bind(this)
        this.onChangeActingPetChecked = this.onChangeActingPetChecked.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getApplyInfo()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({
                    isLoadCompleted: true,
                },
            )
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getApplyInfo(): Promise<void> {
        const [petBreedingResponse, applicationStatusResponse] = await Promise.all([
            this.getPetBreeding(),
            this.getApplicationStatus(),
        ])

        if (petBreedingResponse && applicationStatusResponse) {
            let residentApplyProcess
            if (petBreedingResponse.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) {
                residentApplyProcess = RESIDENT_APPLY_PROCESS.RECEPTION
            } else if (petBreedingResponse.applyStatus === RESIDENT_APPLY_STATUS.PET_CHAIRMAN_WAITING.value) {
                residentApplyProcess = RESIDENT_APPLY_PROCESS.PET_CHAIRMAN_APPROVAL
            } else {
                residentApplyProcess = RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL
            }
            const [healthCenterDogLicenseDataUrl, rabiesPreventionInjectionCertificationDataUrl] = await Promise.all([
                this.getDataUrl(petBreedingResponse.healthCenterDogLicense.path),
                this.getDataUrl(petBreedingResponse.rabiesPreventionInjectionCertification.path),
            ])

            this.setState({
                petBreedingDetail: petBreedingResponse,
                healthCenterDogLicenseDataUrl: healthCenterDogLicenseDataUrl,
                rabiesPreventionInjectionCertificationDataUrl: rabiesPreventionInjectionCertificationDataUrl,
                applicationStatusDetail: applicationStatusResponse,
                residentApplyProcess: residentApplyProcess,
            })
        }
    }

    async getPetBreeding(): Promise<Nullable<NatPetBreedingDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getPetBreeding.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    async getApplicationStatus(): Promise<Nullable<NatGetApplicationStatusDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getApplicationStatus.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    async getDataUrl(url: string): Promise<string> {
        const {fileRepo, eventEmitter} = this.props

        if (!url) {
            return ''
        }
        const response = await this.props.asyncCallFunction(
            fileRepo.getDataUrl.bind(fileRepo, url),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response : ''
    }

    handleDialogCancelClick(): void {
        this.setState({dialogStatus: null, actingChecked: true, receptionComment: '', approvalComment: ''})
    }

    handleReceptionClick(): void {
        this.setState({dialogStatus: 'reception'})
    }

    handleRejectionClick(): void {
        this.setState({dialogStatus: 'rejection'})
    }

    handleApprovalClick(): void {
        this.setState({dialogStatus: 'approval'})
    }

    handleDelegateClick(): void {
        this.setState({dialogStatus: 'delegate'})
    }

    handleDelegatePetClubClick(): void {
        this.setState({dialogStatus: 'delegatePetClub', actingPetChecked: true})
    }

    handleDelegateApprovalClick(): void {
        this.setState({dialogStatus: 'delegateApproval'})
    }

    handleDelegateApprovalPetClubClick(): void {
        this.setState({dialogStatus: 'delegateApprovalPetClub'})
    }

    handleDelegateRejectionClick(): void {
        this.setState({dialogStatus: 'delegateRejection'})
    }

    handleDelegateRejectionPetClubClick(): void {
        this.setState({dialogStatus: 'delegateRejectionPetClub'})
    }

    handleRejectionCommentChange(value: string): void {
        this.setState({rejectionComment: value})
    }

    handleReceptionCommentChange(value: string): void {
        this.setState({receptionComment: value})
    }

    handleApprovalCommentChange(value: string): void {
        this.setState({approvalComment: value})
    }

    async handleRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, petBreedingDetail, residentApplyProcess} = this.state

        const assocFlag = this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionPetBreedingRequest = {
                operation: residentApplyProcess.value,
                comment: rejectionComment,
                version: petBreedingDetail.version,
            }

            const response: Nullable<NatPutRejectionPetBreedingResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionPetBreeding
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                if (!assocFlag) {
                    this.props.navigate(`${this.ownUrl}`, {
                        replace: true,
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0004.toString('申請'),
                            },
                            refreshToken: getRandomKey(),
                        },
                    })
                } else {
                    this.props.navigate('/admin/applications', {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0006.toString(
                                    '申請',
                                    this.state.petBreedingDetail.applyId,
                                    APPLY_CATEGORY.BREEDING_PETS_APPLY.label),
                            },
                        },
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleReceptionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {receptionComment, petBreedingDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsPetBreedingRequest = {
                operation: residentApplyProcess.value,
                comment: receptionComment,
                version: petBreedingDetail.version,
            }

            const response: Nullable<NatPutApprovalPetBreedingResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalPetBreeding
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0003.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, petBreedingDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsPetBreedingRequest = {
                operation: residentApplyProcess.value,
                comment: approvalComment,
                version: petBreedingDetail.version,
            }

            const response: Nullable<NatPutApprovalPetBreedingResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalPetBreeding
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate('/admin/applications', {
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0005.toString(
                                '申請',
                                this.state.petBreedingDetail.applyId,
                                APPLY_CATEGORY.BREEDING_PETS_APPLY.label),
                        },
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, petBreedingDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsPetBreedingRequest = {
                operation: residentApplyProcess.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: approvalComment,
                version: petBreedingDetail.version,
            }

            const response: Nullable<NatPutApprovalPetBreedingResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalPetBreeding
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0007.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateApprovalPetClubOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, petBreedingDetail, residentApplyProcess, actingPetChecked} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsPetBreedingRequest = {
                operation: residentApplyProcess.value,
                comment: approvalComment,
                version: petBreedingDetail.version,
            }
            if (actingPetChecked) {
                request.irregularPattern = APPLY_IRREGULAR_PATTERN.NO_PET_CLUB.value
            }

            const response: Nullable<NatPutApprovalPetBreedingResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalPetBreeding
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0007.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, petBreedingDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionPetBreedingRequest = {
                operation: RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: rejectionComment,
                version: petBreedingDetail.version,
            }

            const response: Nullable<NatPutRejectionPetBreedingResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionPetBreeding
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0004.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateRejectionPetClubOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, petBreedingDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionPetBreedingRequest = {
                operation: RESIDENT_APPLY_PROCESS.PET_CHAIRMAN_APPROVAL.value,
                comment: rejectionComment,
                version: petBreedingDetail.version,
            }

            const response: Nullable<NatPutRejectionPetBreedingResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionPetBreeding
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0004.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeActingChecked(checked: boolean): void {
        this.setState({actingChecked: !checked})
    }

    onChangeActingPetChecked(value: string): void {
        let actingPetCheck = false
        if (value === HAVE_OR_NOT.HAVE.value) {
            actingPetCheck = true
        }
        this.setState({actingPetChecked: !actingPetCheck, actingChecked: false})
    }

    renderDetailsTable(): ReactNode {
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            petType,
            petBreed,
            havePetStartMonth,
            healthCenterDogLicense,
            rabiesPreventionInjectionCertification,
            version,
        } = this.state.petBreedingDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <>
                <Table>
                    <StyledTableCaption>申請内容</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請ID</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {applyId}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請区分</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {APPLY_CATEGORY.BREEDING_PETS_APPLY.label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請者</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {condominiumName + '　' + applicant}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請日</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {moment(applyDate).format('YYYY年M月D日 H時m分')}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>種類</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {PET_TYPE.codeToEnumConstants(petType).label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>品種</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {petBreed}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>飼育開始月</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {getFormattedDate(havePetStartMonth)}
                            </StyledTableCell>
                        </TableRow>
                        {(petType === PET_TYPE.DOG.value) ?
                            <TableRow>
                                <TableRowNameTop>保健所犬鑑札</TableRowNameTop>
                                <StyledTableCell colSpan={4}>
                                    <TableCellImg>
                                        <CondominiumImg src={
                                            healthCenterDogLicense.path + '?' + String(version)
                                        }/>
                                    </TableCellImg>
                                </StyledTableCell>
                            </TableRow> : null}
                        {(petType === PET_TYPE.DOG.value) ?
                            <TableRow>
                                <TableRowNameTop>狂犬病予防注射済証</TableRowNameTop>
                                <StyledTableCell colSpan={4}>
                                    <TableCellImg>
                                        <CondominiumImg src={
                                            rabiesPreventionInjectionCertification.path + '?' + String(version)
                                        }/>
                                    </TableCellImg>
                                </StyledTableCell>
                            </TableRow> : null}
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageHeaderArea(): ReactNode {
        const {
            petBreedingDetail,
            healthCenterDogLicenseDataUrl,
            rabiesPreventionInjectionCertificationDataUrl,
        } = this.state

        return (
            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                <Box mt={'20px'}>
                    <RightRowFlexContainer>
                        <ReactToPrint
                            trigger={() => (
                                <PrintLink>
                                    <Box ml={'10px'}>
                                        印刷する
                                    </Box>
                                </PrintLink>
                            )}
                            content={() => this.applicationRef.current}/>
                        <PrintContentArea>
                            <div ref={this.applicationRef}>
                                <NatPetBreedingApplicationDocument
                                    petBreedingApplicationDocumentParam={petBreedingDetail}
                                    applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                                    healthCenterDogLicenseDataUrl={healthCenterDogLicenseDataUrl}
                                    rabiesPreventionInjectionCertificationDataUrl={
                                        rabiesPreventionInjectionCertificationDataUrl
                                    }
                                />
                            </div>
                        </PrintContentArea>
                    </RightRowFlexContainer>
                </Box>
            </AuthorityChecker>
        )
    }

    renderPageFooterArea(): ReactNode {
        const {petBreedingDetail} = this.state

        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧に戻る
                    </BackLink>
                </PageFotterAreaLeft>
                {(petBreedingDetail.applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <DelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </DelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><Box ml={'8px'}/>承認する
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
                {(petBreedingDetail.applyStatus === RESIDENT_APPLY_STATUS.PET_CHAIRMAN_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <DelegateApprovalButton onClick={this.handleDelegatePetClubClick}>
                                この申請の承認操作を代行する
                            </DelegateApprovalButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
                {(petBreedingDetail.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><Box ml={'8px'}/>受け付ける
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
            </>
        )
    }

    renderPc(): ReactNode {
        return (<>
            <Box mb={'20px'}>
                {this.renderPageHeaderArea()}
            </Box>
            <PageMainArea>
                {this.renderDetailsTable()}
                <NatApplicationStatusComponent
                    currentApplyStatus={this.state.petBreedingDetail.applyStatus}
                    applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                />
            </PageMainArea>
            <PageFooterArea>
                {this.renderPageFooterArea()}
            </PageFooterArea>
        </>)
    }

    renderSpCommentToAssocDirector(): ReactNode {
        const {petBreedingDetail, applicationStatusDetail} = this.state
        if (petBreedingDetail.applyStatus !== RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) {
            return null
        }

        const commentToAssocDirectorInfo = applicationStatusDetail.applyStatusInfo
            .find(status => status.applyProcess === RESIDENT_APPLY_PROCESS.PET_CHAIRMAN_APPROVAL.value)
            ?.actual

        if (!(commentToAssocDirectorInfo?.comment)) {
            return null
        }

        return <Box pb={'16px'}>
            <NatAdminApplicationCommentToAssocDirector
                comment={commentToAssocDirectorInfo.comment}
                roleId={commentToAssocDirectorInfo.roleId}
                familyName={commentToAssocDirectorInfo.familyName}
                firstName={commentToAssocDirectorInfo.firstName}
                registerDatetime={commentToAssocDirectorInfo.registerDatetime}
            />
        </Box>
    }

    renderSpApplicationInfo(): ReactNode {
        const {
            petBreedingDetail,
            healthCenterDogLicenseDataUrl,
            rabiesPreventionInjectionCertificationDataUrl,
        } = this.state
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            applyStatus,
        } = petBreedingDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <SpApplicationInfoArea>
                <LeftColumnFlexContainer>
                    <div>{applyId}</div>
                    <FullWidthRowFlexContainer>
                        <SpApplyCategory>
                            {APPLY_CATEGORY.BREEDING_PETS_APPLY.label}
                        </SpApplyCategory>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                            <ReactToPrint
                                trigger={() => (
                                    <PrintLink>
                                        <Box ml={'10px'}>
                                            印刷する
                                        </Box>
                                    </PrintLink>
                                )}
                                content={() => this.applicationRef.current}/>
                            <PrintContentArea>
                                <div ref={this.applicationRef}>
                                    <NatPetBreedingApplicationDocument
                                        petBreedingApplicationDocumentParam={petBreedingDetail}
                                        applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                                        healthCenterDogLicenseDataUrl={healthCenterDogLicenseDataUrl}
                                        rabiesPreventionInjectionCertificationDataUrl={
                                            rabiesPreventionInjectionCertificationDataUrl
                                        }
                                    />
                                </div>
                            </PrintContentArea>
                        </AuthorityChecker>
                    </FullWidthRowFlexContainer>
                    <Box pt={'12px'}>
                        <div>{condominiumName}</div>
                        <div>{applicant}</div>
                    </Box>
                    <Box height={'12px'}/>
                    <SpApplicationInfoFooter>
                        <div>
                            {formatDateTimeWithoutSeconds(applyDate)} に提出
                        </div>
                        <SpApplyStatusCell status={applyStatus}>
                            {RESIDENT_APPLY_STATUS.codeToEnumConstants(applyStatus).label}
                        </SpApplyStatusCell>
                    </SpApplicationInfoFooter>
                </LeftColumnFlexContainer>
            </SpApplicationInfoArea>
        )
    }

    renderSpPageFooterArea(): ReactNode {
        const {applyStatus} = this.state.petBreedingDetail
        return (
            <>
                {(applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <SpDelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </SpDelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><ApplyButtonTextWithIcon>承認する</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
                {(applyStatus === RESIDENT_APPLY_STATUS.PET_CHAIRMAN_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <SpDelegateApprovalButton onClick={this.handleDelegatePetClubClick}>
                                この申請の承認操作を代行する
                            </SpDelegateApprovalButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
                {(applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><ApplyButtonTextWithIcon>受け付ける</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
            </>
        )
    }

    renderSpApplicationDetailInfo(): ReactNode {
        const {
            petType,
            petBreed,
            havePetStartMonth,
            healthCenterDogLicense,
            rabiesPreventionInjectionCertification,
            version,
        } = this.state.petBreedingDetail
        return (
            <>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>種類</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {PET_TYPE.codeToEnumConstants(petType).label}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>品種</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {petBreed}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>飼育開始月</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {getFormattedDate(havePetStartMonth)}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                {petType === PET_TYPE.DOG.value &&
                    <>
                        <SpApplicationDetailInfoContent>
                            <SpApplicationDetailInfoContentName>保健所犬鑑札</SpApplicationDetailInfoContentName>
                            <SpApplicationDetailInfoContentValue>
                                <CondominiumImg src={
                                    healthCenterDogLicense.path + '?' + String(version)
                                }/>
                            </SpApplicationDetailInfoContentValue>
                        </SpApplicationDetailInfoContent>
                        <SpApplicationDetailInfoContent>
                            <SpApplicationDetailInfoContentName>狂犬病予防注射済証</SpApplicationDetailInfoContentName>
                            <SpApplicationDetailInfoContentValue>
                                <CondominiumImg src={
                                    rabiesPreventionInjectionCertification.path + '?' + String(version)
                                }/>
                            </SpApplicationDetailInfoContentValue>
                        </SpApplicationDetailInfoContent>
                    </>
                }
                {this.renderSpPageFooterArea()}
            </>
        )
    }

    renderSpApplicationStatusInfo(): ReactNode {
        return (
            <NatApplicationStatusComponent
                currentApplyStatus={this.state.petBreedingDetail.applyStatus}
                applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
            />
        )
    }

    renderSp(): ReactNode {
        return (
            <>
                <SpBackLinkArea>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧
                    </BackLink>
                </SpBackLinkArea>
                {this.renderSpApplicationInfo()}
                <Box height={'16px'}/>
                {this.renderSpCommentToAssocDirector()}
                <NatAdminSpApplicationTabComponent
                    detailInfo={this.renderSpApplicationDetailInfo()}
                    statusInfo={this.renderSpApplicationStatusInfo()}
                />
                <Box height={`32px`}/>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const spMode = this.context.showSpModePage

        return (
            <>
                {spMode ? this.renderSp() : this.renderPc()}
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'rejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationReceptionDialog
                    open={this.state.dialogStatus === 'reception'}
                    onCancel={this.handleDialogCancelClick}
                    onReception={this.handleReceptionOkClick}
                    onChange={this.handleReceptionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'approval'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onApproval={this.handleApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDelegateDialog
                    open={this.state.dialogStatus === 'delegatePetClub'}
                    delegateComponent={<NatAdminApplicationApprovalPetChairmanDelegateComponent
                        onChange={this.onChangeActingPetChecked}/>}
                    rejectionButtonDisabled={this.state.actingPetChecked}
                    approvalButtonDisabled={this.state.actingChecked}
                    onApproval={this.handleDelegateApprovalPetClubClick}
                    onRejection={this.handleDelegateRejectionPetClubClick}
                    onCancel={this.handleDialogCancelClick}
                />
                <NatAdminApplicationApprovalDelegateDialog
                    open={this.state.dialogStatus === 'delegate'}
                    delegateComponent={<NatAdminApplicationApprovalDirectorDelegateComponent
                        onChange={this.onChangeActingChecked}/>}
                    rejectionButtonDisabled={this.state.actingChecked}
                    approvalButtonDisabled={this.state.actingChecked}
                    onApproval={this.handleDelegateApprovalClick}
                    onRejection={this.handleDelegateRejectionClick}
                    onCancel={this.handleDialogCancelClick}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'delegateApproval'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onApproval={this.handleDelegateApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'delegateApprovalPetClub'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={
                        this.state.actingPetChecked ?
                            APPLY_IRREGULAR_PATTERN.NO_PET_CLUB :
                            undefined
                    }
                    onApproval={this.handleDelegateApprovalPetClubOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'delegateRejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleDelegateRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'delegateRejectionPetClub'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleDelegateRejectionPetClubOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
            </>
        )
    }
}

NatAdminPetBreedingPage.contextType = AppAdminContext
export default createAdminPage(NatAdminPetBreedingPage)


const TableCellImg: StyledDiv = styled.div`
  width: 400px;
`

const CondominiumImg: StyledImg = styled.img`
  max-width: 253px;
  max-height: 168px;
`
